<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {};
        },
        mounted() {
            console.log("App component mounted.");
        },
    };
</script>
